import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "10", r: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M22 20V8h-4l-6-4-6 4H2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M6 17v.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 13v.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 17v.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 13v.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 22v-5a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "School2";
const School2 = memo(themed(Icon));
export {
  School2
};
//# sourceMappingURL=school-2.js.map
